export const OriginOptions = [
  { value: "Entrada", label: "Entrada" },
  { value: "Saída", label: "Saída" }
]